<form class="app-flex-form" (click)="debugForm(constructor.name)" (keydown)="(null)">
  @for (filter of filters(); track $index) {
    @if (currentFilterView() === filter.label && filter.column === planAdminFilterKey.BillingCycle) {
      <mat-selection-list [formField]="formTree.billingCycle">
        <mat-list-option [value]="'monthly'" (click)="$event.stopPropagation()"> Mensuel </mat-list-option>
        <mat-list-option [value]="'quarterly'" (click)="$event.stopPropagation()">
          Trimestriel
        </mat-list-option>
        <mat-list-option [value]="'yearly'" (click)="$event.stopPropagation()"> Annuel </mat-list-option>
      </mat-selection-list>
    }
    @if (currentFilterView() === filter.label && filter.column === planAdminFilterKey.IsActive) {
      <mat-selection-list [formField]="formTree.isActive">
        <mat-list-option [value]="'true'" (click)="$event.stopPropagation()"> Actif </mat-list-option>
        <mat-list-option [value]="'false'" (click)="$event.stopPropagation()"> Inactif </mat-list-option>
      </mat-selection-list>
    }
  }
</form>
